import { Card } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { getProjectPath, ProjectPath } from '@utils/getMenuContent';
import { useSummaryCards } from '@pages/project/summary/_utils/contexts/SummaryCardsContext';
import { SummaryCardContent } from './components/SummaryCardContent';
import { SummaryCardTitle } from './components/SummaryCardTitle';
import s from './SummaryCards.module.scss';

export function VulnerabilityManagementCard(): ReactNode {
    const { pid } = useParams<{ pid: string }>() as { pid: string };
    const { data } = useSummaryCards();

    const mitigationsCount = data?.mitigationsCount ?? 0;

    return (
        <Card
            title={
                <SummaryCardTitle
                    icon="healing"
                    title="Vulnerability management"
                    iconClassName={s.errorIcon}
                />
            }
            cardClassName={s.card}
            foldable={false}
        >
            <SummaryCardContent
                footer={
                    <div className="flex justify-content-between text-white gap-8 mr-8 w-full">
                        <div className="flex flex-column">
                            <h2 className="text-white">{mitigationsCount}</h2>
                            <strong>Planned mitigations</strong>
                        </div>
                    </div>
                }
                footerClassName="align-items-end"
                to={getProjectPath(ProjectPath.SecurityNotifications, pid)}
            />
        </Card>
    );
}
